package com.patronat.top.ui.models

data class SelectGroup(
    val id: String,
    val label: String,
    val options: List<SelectOption>
)
